<template>
    <div :class="{'selectt': infoReseauxTempo.select}">
      <div class="container_img_info">
        <img :src="url" class="imageBg" alt="">
        <div class="dot_select" @click="contolSelect()"
          :class="{'dot_select1': infoReseauxTempo.select}">
          <div class="dot_selected" v-if="infoReseauxTempo.select"></div>
        </div>
        <div @click="show = true" class="level is-mobile bgBlurMobile">
          <div class="has-text-white">
            <div class="media" >
              <b-icon
                icon="timer"
                class="media-left margin_small">
              </b-icon>
              <div class="media-content is-size-7">
                  <label>Période d'affichage</label><br>
                  <label class="has-text-weight-bold">{{periode}}</label>
              </div>
            </div>
          </div>
          <div
            class="level-right"
            v-if="getTarif">
            <h3 class="has-text-weight-bold has-text-white goToLeft">
              {{tarif(getTarif)}} HT
            </h3>
          </div>
        </div>
      </div>
      <div @click="show = true" class="has-background-white infoBorder">
        <div class="level is-marginless">
          <div class="topViolet leftViolet bottomVert">
            <p class="is-size-7">
              <label class="has-text-default">Nom du réseau</label> <br>
              <strong class="p_size12 has-text-weight-bold has-text-link">
                {{infoReseauxTempo.libelle}}</strong>
            </p>
          </div>
        </div>
        <div class="column leftViolet rightViolet">
          <div class="columns is-multiline is-mobile color-icon">
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                    <label class="has-text-default"> Durée </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">{{duree}}</p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="city"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                    <label class="has-text-default"> Ville </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{infoReseauxTempo.ville}}
                    </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                    <label class="has-text-default"> Format </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{infoReseauxTempo.format}}
                    </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                    <label class="has-text-default">Nombre de faces</label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{infoReseauxTempo.nbFaces}}
                    </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="calendar-check"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                    <label class="has-text-default"> Jour de depart </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">{{jour}}
                    </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-12"
              v-if="infoReseauxTempo.extensionOpportunite.commentaire">
              <div class="media">
                <div class="media-content">
                    <label class="has-text-weight-bold has-text-link p_size14">
                      Commentaire : </label><br>
                    <p class="p_size12 has-text-default has-text-link">
                      {{infoReseauxTempo.extensionOpportunite.commentaire}}
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a>
          <p class="p_size14 has-text-centered has-text-white color-plus-info">
            Plus d'informations</p>
        </a>
      </div>
      <app-detail-tempo-diapo :detailFace="infoReseauxTempo"
      :idOpportunite="idOpportunite" v-if="show"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatJour, calPeriode, urlPhoto, formatNum, formatDuree } from '@/services/opportunite/formatTab';
import detailTempoDiapo from './detailTempoDiapo';

export default {
  name: 'infoReseauxTempo',
  components: {
    appDetailTempoDiapo: detailTempoDiapo,
  },
  props: ['infoReseauxTempo', 'idOpportunite'],
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxTempo.urlPhoto);
    },
    periode() {
      if (this.infoReseauxTempo.extensionOpportunite.newPeriode) {
        return this.infoReseauxTempo.extensionOpportunite.newPeriode;
      }
      const d = this.infoReseauxTempo.extensionOpportunite.jourDepart;
      const w = this.infoReseauxTempo.extensionOpportunite.semaine;
      const y = this.infoReseauxTempo.extensionOpportunite.annee;
      return calPeriode(d, w, y);
    },
    jour() {
      return formatJour(this.infoReseauxTempo.jourDepart);
    },
    duree() {
      return formatDuree(this.infoReseauxTempo.dureeConservation);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxTempo.extensionOpportunite.tarifDePose) {
        tarifDePose = this.infoReseauxTempo.extensionOpportunite.tarifDePose;
      }
      if (this.infoReseauxTempo.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxTempo.extensionOpportunite.taxeMunicipale;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifImpression) {
        tarifImpression = this.infoReseauxTempo.extensionOpportunite.tarifImpression;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifHT) {
        tarifHT = this.infoReseauxTempo.extensionOpportunite.tarifHT;
      }
      if (this.infoReseauxTempo.extensionOpportunite.tarifNet) {
        tarifNet = this.infoReseauxTempo.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxTempo.select = !this.infoReseauxTempo.select;
      if (this.infoReseauxTempo.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    tarif(t) {
      return formatNum(t);
    },
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxTempo/infoReseauxTempo.vue